import React, {useEffect, useState} from 'react';
import {Card} from "primereact/card";
import {Dropdown} from "primereact/dropdown";
import {Button} from "primereact/button";
import {useNavigate, useSearchParams} from "react-router-dom";
import useApi from "../../../../hooks/useApi";
import {webInfo} from "../../../../utils/webInfo";
import {depots} from "../../../../utils/helper";
import TableSkeleton from "../../../../Loader/Loader";
import ErrorPresentor from "../../../../ErrorPresentor/ErrorPresentor";
import CropTable from "./CropTable";
import {InputText} from "primereact/inputtext";

const Crop = () => {
    const [params,setParams]:any = useSearchParams();
    const navigate = useNavigate();
    const [selectedCategory, setSelectedCategory] = useState<any>({name: 'Select Category', code: null});
    const [update,setUpdate] = useState(false)
    const [total, setTotal] = useState(0);
    const [page, setPage] = useState(1);
    const [perPage] = useState(10);
    const {get:getProduct, loading:gploading,error} = useApi<any>();
    const {get:getCategory, loading:gcloading} = useApi<any>();
    const [products, setProducts] = useState<any>([]);
    const [categories,setCategories] = useState([]);
    const categoryUrl = `${webInfo.baseUrl}/api/admin/products-crop-category?page=1&per_page=200`
    const onPageChange = (event: any) => {
        setPage(event.page + 1);
    }
    const [search,setSearch] = useState('');
    const urlBuilder = (page:number,perPage:number,search:string,category:number) => {
        let url = `${webInfo.baseUrl}/api/admin/products-crop?page=${page}&per_page=${perPage}`

        if (search.trim() !== '' && category !==null && category !==undefined && search.trim() !== 'undefined' && search.trim() !== 'null'){
            url += `&search=${search}&product_crop_care_category_id=${category}`
        }
        else if (category !==null && category !==undefined){
            url += `&product_crop_care_category_id=${category}`
        }
        else if (search.trim() !== '' && search.trim() !== 'undefined' && search.trim() !== 'null') {
            url += `&search=${search}`;
        }

        // console.log("url after change", url)
        return url;
    }
    useEffect(() => {
        const url =  urlBuilder(page,perPage,search,selectedCategory.code)
        const fetchProducts = async () => {
            try {
                const res: any = await getProduct(url);
                setProducts(res.data.data);
                setTotal(res.data.total);
            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };
        fetchProducts();
        // eslint-disable-next-line
    }, [page, perPage,update,selectedCategory.code]);

    const handleSearch = async (searchValue = search) => {
        const url = urlBuilder(1, perPage, searchValue, selectedCategory.code);
        try {
            const res: any = await getProduct(url);
            setProducts(res.data.data);
            setTotal(res.data.total);
        } catch (err) {
            console.error("Failed to fetch products", err);
        }
    };

    useEffect(() => {
        const fetchCategories = async () => {
            try {
                const res: any = await getCategory(categoryUrl);
                const options = res.data.data.map((item:any)=>({
                    name: item.name,
                    code: item.id,
                }));
                setCategories(options);
                const code = params.get('category_code');
                if (code) {
                    const matched = options.find((o:any) => Number(o.code) === Number(code));
                    if (matched) setSelectedCategory(matched);
                }

            } catch (err) {
                console.error("Failed to fetch products", err);
            }
        };

        fetchCategories();
        // eslint-disable-next-line
    }, []);

    const header = (
        <div className='flex align-items-center justify-content-between p-4 pb-0'>
            <h4 className="m-0">{depots[3].name} Products</h4>
            <div className="flex align-items-center">
                <Dropdown
                    showClear={selectedCategory.code !== null}
                    value={selectedCategory.code ? selectedCategory : null}
                    onChange={(e) => {
                        const value = e.value;
                        setSelectedCategory(value || {name: 'Select Category', code: null});
                        const newParams = new URLSearchParams(window.location.search);
                        if (value?.code) {
                            newParams.set("category_code", value.code);
                        } else {
                            newParams.delete("category_code");
                        }
                        setParams(newParams);
                        setPage(1);
                    }}
                    options={categories}
                    optionLabel="name"
                    placeholder={gcloading ? "Loading Category" : "Search by Category"}
                    className="w-full md:w-14rem mr-2"
                />

                <div className="relative w-full md:w-14rem mr-2">
                    <div className="p-inputgroup flex-1 w-full ">
                        <span className="p-input-icon-right w-full">
                            <InputText
                                placeholder="Search by Brand "
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                                className="w-full pr-5 border-noround-right"
                            />

                            {search && (
                                <i
                                    className="pi pi-times cursor-pointer"
                                    onClick={() => {
                                        setSearch("");
                                        handleSearch("");
                                    }}

                                    style={{
                                        position: "absolute",
                                        right: "1rem",
                                        top: "70%",
                                        transform: "translateY(-50%)"
                                    }}
                                />
                            )}
                        </span>

                        <Button
                            icon="pi pi-search"
                            onClick={() => handleSearch()}
                            disabled={!search}
                        />
                    </div>
                </div>
                <Button onClick={()=>navigate("/products/create?division=11")} label="Create New" icon="pi pi-plus" iconPos="right" />
            </div>
        </div>
    )

    return (
        <Card header={header}>
            {gploading ? <TableSkeleton/> : <div>
                {error ? <ErrorPresentor error={error}/> : <CropTable products={products} total={total} onPageChange={onPageChange} page={page} perPage={perPage} categories={categories} update={update} setUpdate={setUpdate} />}
            </div>}
        </Card>
    );
};

export default Crop;